import { cloneDeep } from 'lodash';

import {
  ACTION_INVENTORY_START,
  ACTION_INVENTORY_END,
  SEARCH_INVENTORY,
  GET_AUDIT_TRAIL,
  INVENTORY_LOG_COUNT,
  SEARCH_INVENTORY_DETAIL,
  GET_DRIVER_STATUS,
  GET_INVENTORY_COUNT,
  CANCEL_DRIVER_REQUEST,
  CAR_MOVEMENT,
  SLOT_PREFERENCE_SAVED,
  UPDATE_INVENTORY_STATE,
  CHANGE_INVENTORY_STATE_LOCAL,
  CHANGE_CAR_MOVEMENT_STATUS_LOCAL,
  SLOT_PREFERENCE_SAVED_LOCAL,
  CHANGE_DRIVER_RETURN_STATUS,
  REFESH_PAGE,
  CHANGE_LIST_PRICING,
  CHANGE_LIST_PRICING_LOCAL,
  CHANGE_TARGET_PRICE,
  CHANGE_TARGET_PRICE_LOCAL,
  LOGISTIC_MOVEMENT,
  LOGISTIC_MOVEMENT_LOCAL,
  REASONS,
  CHANGE_PARKING_SLOT_LOCAL,
  UPDATE_PARKING_SLOT,
  CHANGE_PUBLISH_STATUS,
  CHANGE_PUBLISH_STATUS_LOCAL,
  SAVED_UPLOAD_FILE,
  TIME_SLOTS,
  ACTION_EXPORT_CSV,
  BULK_UPLOAD_STATUS,
  BULK_UPLOAD_STATUS_DETAILS,
  BULK_UPLOAD_STATUS_COUNT,
  UI_RULES,
  INSPECTION_DATA,
  ADDRESS_FILL,
  GEO_TO_ADDRESS,
  UPDATE_INVENTORY_STAGE,
  CHANGE_INVENTORY_STAGE_LOCAL,
  UPDATE_INVENTORY_TYPE,
  CHANGE_INVENTORY_TYPE_LOCAL,
  POST_INSPECTION_DATA,
  SEARCH_INSPECTION_DETAIL,
  CHANGE_EGC_VALUE,
  CHANGE_EGC_VALUE_LOCAL,
  CHANGE_RESERVE_STATUS,
  CHANGE_RESERVE_STATUS_LOCAL,
  GET_TEAMS,
  GET_EXTERNAL_DELIVERY_ALLOWED,
  GET_PAYMENT_DETAILS,
  ACTION_APT_ORDERS_START,
  ACTION_APT_ORDERS_END,
  ACTION_APT_ORDERS,
  GET_LOCUS_TEAMS,
  ACTION_INVENTORY_ASSETS,
  DOCUMENT_PENDENCY_START,
  DOCUMENT_PENDENCY_END,
  DOCUMENT_PENDENCY_SEARCH,
  FETCH_FIELD_AUDIT_HISTORY,
  SUCCESS_FIELD_AUDIT_HISTORY,
  ERROR_FIELD_AUDIT_HISTORY,
  GET_CONTACT_PERSONS,
  UPDATE_SELECTED_INVENTORIES,
  INVENTORY_ORDERS_SUCCESS,
  CHANGE_PARENT_HUB,
  CHANGE_PARENT_HUB_LOCAL,
  CHANGE_NUMBER_PLATE,
  CHANGE_NUMBER_PLATE_LOCAL,
} from '../actions/inventoryManagement/inventoryManagement.actiontype';
import { AlertType } from '../../utils/constants/values.constants';

const initialState = {
  isProcessing: false,
  inventories: [],
  auditTrail: {},
  inventoryCount: 0,
  driverStatus: {},
  cancelStatus: {},
  auditTrailCount: 0,
  updatedInventoryState: {},
  carMovementStatus: {},
  logisticMovementStatus: {},
  reasons: [],
  showToaster: false,
  toasterMessage: '',
  toasterType: '',
  listPricingStatus: '',
  targetPriceStatus: '',
  egcValueStatus: '',
  publishStatus: '',
  uploadFile: '',
  timeSlots: {},
  csvData: '',
  bulkUploadStatus: [],
  buldStatusDetails: [],
  bulkUploadStatusCount: 0,
  uiRulesData: {},
  inspectionData: {},
  paymentStatus: {},
  addressById: {},
  addressByGeo: {},
  refeshPage: {},
  parkingSlotValue: '',
  inventoryStage: '',
  inventoryStageStatus: '',
  inventoryType: '',
  inventoryTypeStatus: '',
  postInspectionData: [],
  teams: [],
  externalDeliveryAllowed: true,
  stockOutOrders: [],
  locusTeams: [],
  inventoryAsset: [],
  documentPendency: {},
  inventoryFieldAuditHistory: [],
  contactPersons: [],
  inventoryPendingActions: [],
  inventoryOrders: [],
  parentHubLocationStatus: '',
  parentNumberPlateStatus: '',
};

const InventoryManagement = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_INVENTORY_START:
      return {
        ...state,
        isProcessing: true,
      };

    case ACTION_INVENTORY_END: {
      return {
        ...state,
        isProcessing: false,
      };
    }

    case ACTION_APT_ORDERS_START:
      return {
        ...state,
        isProcessing: true,
      };

    case ACTION_APT_ORDERS_END: {
      return {
        ...state,
        isProcessing: false,
      };
    }

    case ACTION_APT_ORDERS: {
      return {
        ...state,
        stockOutOrders: action.payload,
        isProcessing: false,
      };
    }

    case GET_TEAMS: {
      return {
        ...state,
        teams: action.payload,
        isProcessing: false,
      };
    }

    case SEARCH_INVENTORY: {
      return {
        ...state,
        inventoriesDetail: {},
        inventories: action.payload,
        isProcessing: false,
      };
    }

    case UPDATE_SELECTED_INVENTORIES: {
      let inventories = cloneDeep(state.inventories);
      let updatedSelectedInventories = action.payload;

      updatedSelectedInventories.forEach((selectedInv) => {
        let index = inventories.findIndex(
          (inv) =>
            inv.inventory.appointmentId === selectedInv.inventory.appointmentId
        );
        if (index !== -1) {
          inventories.splice(index, 1, selectedInv);
        }
      });

      return {
        ...state,
        inventories,
        inventoriesDetail: {},
      };
    }

    case ADDRESS_FILL: {
      return {
        ...state,
        addressById: action.payload,
      };
    }

    case GEO_TO_ADDRESS: {
      return {
        ...state,
        addressByGeo: action.payload,
      };
    }

    case REFESH_PAGE: {
      return {
        ...state,
        refeshPage: action.payload,
      };
    }

    case UPDATE_PARKING_SLOT: {
      return {
        ...state,
        parkingSlotValue: action.payload,
        isProcessing: false,
      };
    }

    case UPDATE_INVENTORY_STAGE: {
      return {
        ...state,
        inventoryStageStatus: action.payload,
        isProcessing: false,
      };
    }

    case UPDATE_INVENTORY_TYPE: {
      let inventoryDetail = state.inventoriesDetail;

      return {
        ...state,
        inventoryDetail,
        inventoryTypeStatus: action.payload,
        isProcessing: false,
      };
    }

    case GET_INVENTORY_COUNT: {
      return {
        ...state,
        inventoryCount: action.payload,
      };
    }

    case SEARCH_INVENTORY_DETAIL: {
      return {
        ...state,
        inventoriesDetail: action.payload,
        driverStatus: {},
        isProcessing: false,
      };
    }

    case SEARCH_INSPECTION_DETAIL: {
      return {
        ...state,
        inspectionDetail: action.payload,
        isProcessing: false,
      };
    }

    case GET_PAYMENT_DETAILS: {
      return {
        ...state,
        paymentStatus: action.payload,
        isProcessing: false,
      };
    }

    case GET_EXTERNAL_DELIVERY_ALLOWED: {
      return {
        ...state,
        externalDeliveryAllowed: action.payload,
        isProcessing: false,
      };
    }

    case GET_AUDIT_TRAIL: {
      return {
        ...state,
        auditTrail: action.payload,
        isProcessing: false,
      };
    }

    case ACTION_EXPORT_CSV: {
      return {
        ...state,
        csvData: action.payload,
        isProcessing: false,
      };
    }

    case SAVED_UPLOAD_FILE: {
      return {
        ...state,
        uploadFile: action.payload,
        isProcessing: false,
      };
    }

    case TIME_SLOTS: {
      return {
        ...state,
        timeSlots: action.payload,
        isProcessing: false,
      };
    }

    case GET_DRIVER_STATUS: {
      return {
        ...state,
        driverStatus: action.payload,
        isProcessing: false,
      };
    }

    case CANCEL_DRIVER_REQUEST: {
      return {
        ...state,
        cancelStatus: action.payload,
        isProcessing: false,
      };
    }

    case INVENTORY_LOG_COUNT: {
      return {
        ...state,
        auditTrailCount: action.payload,
        isProcessing: false,
      };
    }

    case UPDATE_INVENTORY_STATE: {
      return {
        ...state,
        updatedInventoryState: action.payload.message,
        isProcessing: false,
      };
    }

    case CHANGE_INVENTORY_STATE_LOCAL: {
      return {
        ...state,
        updatedInventoryState: 'reset',
        isProcessing: false,
      };
    }

    case CAR_MOVEMENT: {
      return {
        ...state,
        toasterMessage: 'Pickup request created successfully.',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        carMovementStatus: action.payload,
        isProcessing: false,
      };
    }

    case SLOT_PREFERENCE_SAVED: {
      return {
        ...state,
        toasterMessage: 'Slot preference saved successfully.',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        carMovementStatus: action.payload,
        isProcessing: false,
      };
    }

    case LOGISTIC_MOVEMENT: {
      return {
        ...state,
        logisticMovementStatus: action.payload,
        isProcessing: false,
      };
    }

    case LOGISTIC_MOVEMENT_LOCAL: {
      return {
        ...state,
        logisticMovementStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_CAR_MOVEMENT_STATUS_LOCAL: {
      return {
        ...state,
        carMovementStatus: 'reset',
        isProcessing: false,
      };
    }

    case SLOT_PREFERENCE_SAVED_LOCAL: {
      return {
        ...state,
        carMovementStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_DRIVER_RETURN_STATUS: {
      return {
        ...state,
        cancelStatus: 'reset',
        isProcessing: false,
      };
    }

    case REASONS: {
      return {
        ...state,
        reasons: action.payload,
      };
    }

    case CHANGE_LIST_PRICING: {
      let intentoryDetail = state.inventoriesDetail;
      intentoryDetail.inventory.listingPrice =
        action.payload.params.listingPrice;
      return {
        ...state,
        listPricingStatus: action.payload.message,
        inventoryDetail: intentoryDetail,
        isProcessing: false,
      };
    }

    case CHANGE_LIST_PRICING_LOCAL: {
      return {
        ...state,
        listPricingStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_TARGET_PRICE: {
      let inventoryDetail = state.inventoriesDetail;
      inventoryDetail.inventory.inventoryAttributes.targetPrice =
        action.payload.params.targetPrice;

      return {
        ...state,
        inventoryDetail,
        targetPriceStatus: action.payload.message,
        isProcessing: false,
      };
    }

    case CHANGE_TARGET_PRICE_LOCAL: {
      return {
        ...state,
        targetPriceStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_EGC_VALUE: {
      let inventoryDetail = state.inventoriesDetail;

      return {
        ...state,
        inventoryDetail,
        egcValueStatus: 'success',
        isProcessing: false,
      };
    }

    case CHANGE_EGC_VALUE_LOCAL: {
      return {
        ...state,
        egcValueStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_PARKING_SLOT_LOCAL: {
      return {
        ...state,
        parkingSlotValue: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_INVENTORY_STAGE_LOCAL: {
      return {
        ...state,
        inventoryStageStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_INVENTORY_TYPE_LOCAL: {
      return {
        ...state,
        inventoryTypeStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_PUBLISH_STATUS: {
      let intentoryDetail = state.inventoriesDetail;
      intentoryDetail.inventory.published = action.payload.params.published;
      return {
        ...state,
        publishStatus: action.payload.message,
        inventoryDetail: intentoryDetail,
        isProcessing: false,
      };
    }

    case CHANGE_PUBLISH_STATUS_LOCAL: {
      return {
        ...state,
        publishStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_RESERVE_STATUS: {
      const inventoryDetail = state.inventoriesDetail;
      inventoryDetail.inventory.reserveStatus =
        action.payload.params.reserveStatus;

      return {
        ...state,
        reserveStatus: action.payload.message,
        inventoryDetail: inventoryDetail,
        isProcessing: false,
      };
    }

    case CHANGE_RESERVE_STATUS_LOCAL: {
      return {
        ...state,
        reserveStatus: 'reset',
        isProcessing: false,
      };
    }

    case BULK_UPLOAD_STATUS: {
      return {
        ...state,
        bulkUploadStatus: action.payload,
      };
    }

    case BULK_UPLOAD_STATUS_DETAILS: {
      return {
        ...state,
        buldStatusDetails: action.payload,
      };
    }

    case BULK_UPLOAD_STATUS_COUNT: {
      return {
        ...state,
        bulkUploadStatusCount: action.payload,
      };
    }

    case UI_RULES: {
      return {
        ...state,
        uiRulesData: action.payload,
      };
    }

    case INSPECTION_DATA: {
      return {
        ...state,
        inspectionData: action.payload,
      };
    }

    case POST_INSPECTION_DATA: {
      return {
        ...state,
        postInspectionData: action.payload,
      };
    }

    case GET_LOCUS_TEAMS: {
      return {
        ...state,
        locusTeams: action.payload,
        isProcessing: false,
      };
    }

    case ACTION_INVENTORY_ASSETS: {
      return {
        ...state,
        inventoryAsset: action.payload,
        isProcessing: false,
      };
    }

    case DOCUMENT_PENDENCY_START:
      return {
        ...state,
        isProcessing: true,
      };

    case DOCUMENT_PENDENCY_END: {
      return {
        ...state,
        isProcessing: false,
      };
    }

    case DOCUMENT_PENDENCY_SEARCH: {
      return {
        ...state,
        documentPendency: action.payload,
        isProcessing: false,
      };
    }

    case FETCH_FIELD_AUDIT_HISTORY:
      return {
        ...state,
        isProcessing: true,
      };

    case SUCCESS_FIELD_AUDIT_HISTORY:
      return {
        ...state,
        isProcessing: false,
        inventoryFieldAuditHistory: action.payload,
      };

    case ERROR_FIELD_AUDIT_HISTORY:
      return {
        ...state,
        isProcessing: false,
        inventoryFieldAuditHistory: [],
      };

    case GET_CONTACT_PERSONS: {
      return {
        ...state,
        contactPersons: action.payload ? action.payload : [],
      };
    }

    case 'INVENTORY_PENDING_ACTION_STATUS': {
      return {
        ...state,
        inventoryPendingActions: action.payload,
      };
    }

    case INVENTORY_ORDERS_SUCCESS: {
      return {
        ...state,
        inventoryOrders: action.payload,
      };
    }

    case CHANGE_PARENT_HUB_LOCAL: {
      return {
        ...state,
        parentHubLocationStatus: 'reset',
        isProcessing: false,
      };
    }

    case CHANGE_PARENT_HUB: {
      return {
        ...state,
        isProcessing: false,
        parentHubLocationStatus: action?.payload?.message,
      };
    }

    case CHANGE_NUMBER_PLATE: {
      return {
        ...state,
        isProcessing: false,
        numberPlateStatus: action?.payload?.message,
      };
    }

    case CHANGE_NUMBER_PLATE_LOCAL: {
      return {
        ...state,
        numberPlateStatus: 'reset',
        isProcessing: false,
      };
    }

    default:
      return state;
  }
};

export default InventoryManagement;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
